import {i18n} from '@yourcoach/i18n';

import type {ConferenceApiModel} from '../../../api/conference';
import type {CoreCoachConferencesStopArchiveParams} from '../../../api/types/core/methods';
import type {AsyncStrategy, BaseConfig} from '../utils';

import {conferenceStore} from '../../../api/conference';
import RecordStopIcon from '../../../assets/icons/secondary/Tick Square.svg';
import {alert} from '../../../components/alert';
import {isMeCoachForEntity} from '../../../utils/entity/isMeCoachForEntity';
import {AppError} from '../../../utils/errors/app';

export {conferenceStopRecord};

type Config = BaseConfig<Omit<CoreCoachConferencesStopArchiveParams, '_id'>> & {
  entity: ConferenceApiModel;
};

const strategy: AsyncStrategy = async (roles, config) => {
  return isMeCoachForEntity((config as Config).entity)
    ? roles.coach(config)
    : roles.client(config);
};

async function conferenceStopRecord(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

conferenceStopRecord.asClient = asClient;
conferenceStopRecord.asCoach = asCoach;

async function asClient(_config: Config) {
  throw new AppError('not_allowed');
}

async function asCoach({entity, params}: Config) {
  const result = await conferenceStore.coach.stopArchive(entity, params);

  alert.show({
    icon: RecordStopIcon,
    iconColor: 'icon.primary',
    message: i18n.t('shared:Conference.stop_record_notice.description'),
    title: i18n.t('shared:Conference.stop_record_notice.title'),
  });

  return result;
}
